import { Tooltip as TooltipPrimitive } from 'radix-ui';
import { cn } from '../lib/utils.js';

/** @param {import('react').ComponentProps<typeof TooltipPrimitive.Provider>} props */
export function TooltipProvider({ delayDuration = 300, ...props }) {
  return <TooltipPrimitive.Provider delayDuration={delayDuration} {...props} />;
}

export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

/** @param {import('react').ComponentProps<typeof TooltipPrimitive.Content>} props */
export function TooltipContent({ className, sideOffset = 6, ...props }) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn('z-50 rounded-md bg-foreground px-2 py-1 text-xs text-background shadow-sm', className)}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
}
